<template>
  <div class="modules-container">
    <div class="modules-item left-offset">
      <!-- Total Downloads -->
      <div class="modules-one">
        <div class="item-top">
          <TitleComp :title="titleData && titleData.data1" />
          <div class="animate-wrap">
            <frame-animation urlRoot="matr1xFireIntro/animate/download/download" :indexRange="[1, 3]" :loop="true" :speed="200" />
          </div>
        </div>
        <div class="item-under">
          <count-to :endValue="String(statisticCount.download)" />
        </div>
      </div>

      <!-- Total registrations -->
      <div class="modules-one">
        <div class="item-top">
          <TitleComp :title="titleData && titleData.data2" />
          <div class="animate-wrap">
            <frame-animation urlRoot="matr1xFireIntro/animate/register/register" :indexRange="[1, 3]" :loop="true" :speed="200" />
          </div>
        </div>
        <div class="item-under">
          <count-to :endValue="String(statisticCount.registrations)" />
        </div>
      </div>
    </div>

    <div class="modules-item right-offset" v-show="isChange">
      <!-- Fire Trading Volume -->
      <div class="modules-one">
        <div class="item-top">
          <TitleComp :title="titleData && titleData.data3" />
          <div class="animate-wrap">
            <frame-animation urlRoot="matr1xFireIntro/animate/fire/fire" :indexRange="[1, 3]" :loop="true" :speed="200" />
          </div>
        </div>
        <div class="item-under">
          <count-to :endValue="String(statisticCount.fire)" />
        </div>
      </div>

      <!-- Weapon Case Trading Volume -->
      <div class="modules-one">
        <div class="item-top">
          <TitleComp :title="titleData && titleData.data4" />
          <div class="animate-wrap">
            <frame-animation urlRoot="matr1xFireIntro/animate/box/box" :indexRange="[1, 3]" :loop="true" :speed="200" />
          </div>
        </div>
        <div class="item-under">
          <count-to :endValue="String(statisticCount.case)" />
        </div>
      </div>
    </div>

    <div class="modules-item right-offset" v-show="!isChange">
      <!-- Weapon Case Trading Volume -->
      <div class="modules-one">
        <div class="item-top">
          <TitleComp :title="titleData && titleData.data5" />
          <div class="animate-wrap">
            <frame-animation urlRoot="matr1xFireIntro/animate/case/case" :indexRange="[1, 3]" :loop="true" :speed="200" />
          </div>
        </div>
        <div class="item-under">
          <count-to :endValue="String(statisticCount.box)" />
        </div>
      </div>

      <!-- NFT Trading Volume -->
      <div class="modules-one">
        <div class="item-top">
          <TitleComp :title="titleData && titleData.data6" />
          <div class="animate-wrap">
            <frame-animation urlRoot="matr1xFireIntro/animate/nft/nft" :indexRange="[1, 3]" :loop="true" :speed="200" />
          </div>
        </div>
        <div class="item-under">
          <count-to :endValue="String(statisticCount.nft)" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import FrameAnimation from "@/components/frameAnimation";
import CountTo from "@/components/countTo";
import responsiveMixin from "@/mixins/responsive";
import { statisticCount } from "./json/index.js"
import TitleComp from "../../../title";
export default {
  mixins: [responsiveMixin],
  components: { FrameAnimation, CountTo, TitleComp },
  data() {
    return {
      statisticCount,
      timer: null,
      isChange: true,
      isStart: false
    };
  },
  props: {
    titleData: {
      type: Object,
      default: () => {}
    }
  },
  beforeDestroy() {
    this.timer && clearInterval(this.timer);
  },
  mounted() {
    this.timer = setInterval(() => {
      this.isChange = !this.isChange;
    }, 5000)
  },
  methods: {
    handleIntersect(entry, observer) {
      
      observer.unobserve(entry.target);
    },
  },
  watch: {

  },
};
</script>

<style lang="scss" scoped>
@import "./index.scss";
</style>